import React from "react";

// Icona casa piccola per il tagline (outline bordeaux + stella interna)
export function HouseIconSmall({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M50 12 L14 42 L14 88 L86 88 L86 42 Z" fill="none" stroke="#7D2E3F" strokeWidth="4.5" strokeLinejoin="round" />
      <polygon points="50,52 54,63 66,63 56,70 60,81 50,74 40,81 44,70 34,63 46,63" fill="#7D2E3F" />
    </svg>
  );
}

// Casa vuota tratteggiata (Immobile in vendita)
export function HouseIconEmpty({ className = "w-14 h-14" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M50 12 L14 42 L14 88 L86 88 L86 42 Z" fill="none" stroke="#B8B4AF" strokeWidth="3" strokeDasharray="5 4" strokeLinejoin="round" />
    </svg>
  );
}

// Nota: HouseIconFull rimosso — per la casa piena "Pronto alla Vendita" usare
// l'immagine canonica /brand/bollino-512.png (stella centrata) invece di un SVG
// che rischiava di reintrodurre l'inconsistenza (stella non allineata).
